import { memo } from 'react';
import { Folder } from 'lucide-react';
import { haptics } from '../../../utils/haptics';

/**
 * Compact folder chip in the design browser. Renders as a small pill with a
 * folder icon + name so the folder strip stays out of the way of the design
 * grid below. Click to enter the folder.
 */
const FolderCard = memo(function FolderCard({ folder, onEnter }) {
  const handleEnter = () => {
    haptics.light();
    onEnter?.(folder);
  };

  return (
    <button
      type="button"
      onClick={handleEnter}
      data-folder-id={folder.folder_id}
      aria-label={`Open folder ${folder.name}`}
      title={folder.name}
      className="group inline-flex items-center gap-1.5 max-w-[14rem] pl-1.5 pr-3 py-1 rounded-full border border-foreground/10 bg-foreground/[0.04] hover:bg-primary-500/10 hover:border-primary-500/40 dark:hover:bg-primary-400/15 dark:hover:border-primary-300/40 text-body-sm text-foreground transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/60"
    >
      <span className="flex items-center justify-center w-5 h-5 rounded-full bg-primary-500/10 dark:bg-primary-400/20 text-primary-600 dark:text-primary-300 shrink-0">
        <Folder className="w-3 h-3" strokeWidth={2.25} />
      </span>
      <span className="truncate font-medium">{folder.name}</span>
    </button>
  );
});

export default FolderCard;
